/*
 * QuidPro
 * Copyright (c) 2022, QuidPro.co
 * https://www.quidpro.co
 */

// import dotenv from 'dotenv'
// const env = process.env.NODE_ENV || "production";
// TODO: Handle env variables
const env = "production";
// dotenv.config()

export const firebaseConfig = {
  apiKey: "AIzaSyDN7lqBkvOy5qxGgWdLdwDqgpXwhhaVyQ4",
  authDomain: "quidpro-903c6.firebaseapp.com",
  projectId: "quidpro-903c6",
  storageBucket: "quidpro-903c6.appspot.com",
  messagingSenderId: "874963166934",
  appId: "1:874963166934:web:36fb4376cc892f3895cb77",
  measurementId: "G-XKCBXBRP3D",
  databaseURL: "https://quidpro-v2.firebaseio.com"
};

export const googleWebClientId =
  "874963166934-ednqcddsfai0pggdkdk399p6lko7ga3f.apps.googleusercontent.com";

export const emailVerification = false;
export const functionsURL =
  env === "production"
    ? "https://us-central1-quidpro-903c6.cloudfunctions.net"
    : "http://localhost:5001/quidpro-903c6/us-central1";

export const payfast = {
  url:
    env === "production"
      ? "https://www.payfast.co.za/eng/process"
      : "https://sandbox.payfast.co.za/eng/process",
  merchantId: env === "production" ? "13462043" : "10011386",
  merchantKey: env === "production" ? "dp0gtidr9gmaa" : "7uqe1fktb4eio",
  returnUrl:
    env === "production"
      ? "https://quidpro-903c6.web.app/user"
      : "http://localhost:8100/user",
  notifyUrl:
    env === "production"
      ? "https://us-central1-quidpro-903c6.cloudfunctions.net/payfastNotifyUrl"
      : "http://localhost:5001/quidpro-903c6/us-central1/payfastNotifyUrl",
  passphrase: env === "production" ? "6UjhcGdHf9KhEA2K" : "Yrg4Tu9u5pKW6tFm"
};
